import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { PreviewPageModule } from './preview/preview.module';
import { ReportPageComponent } from './report.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: ReportPageComponent,
    path: ''
  },
  {
    loadChildren: () => PreviewPageModule,
    path: 'preview'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ReportPageRoutingModule {}
